import $ from "jquery";

import Handlebars from '../../libraries/handlebars';
import twbsPagination from '../../libraries/jquery.twbsPagination';
import querystring from './querystring';
import _ from 'underscore';
import handlebarHelpers from './handlebarHelpers';
import merchelloUi from '../../libraries/merchello.ui';
import initAnimations from '../initAnimation';
import productCarousel from "../productCarousel";
import updateMetaTagEnding from "../updateMetaTagEnding";

window.$ = window.jQuery = $;

export default function filteredProducts(opts) {
    var MUI = merchelloUi();
    handlebarHelpers();
    twbsPagination();
    var $pagination,
        $showMoreButton,
        $filtersForm,
        $applyFilterButton,
        $order,
        $topSalesBlock,
        $filterPills,
        $filters = {
            $catalog: {}, $category: {}, $group: {}, $brand: {}, $mobileCatalog: {}, $mobileCategory: {}, $mobileGroup: {}, $mobileBrand: {}
        },
        $dataContainer,
        $topSalesContainer;

    var productListContext = {
        productRows: []
    };

    var topSalesListContext = {
        productRows: []
    };

    var timeList = {
        template: {},
        source: {},
        render: function (data) {
            if (!data.result.items) {
                return;
            }
            productListContext = {
                productRows: _.chunk(data.result.items, 4)
            };
            var html = this.template(productListContext);
            if (pagination.isShowMore) {
                $dataContainer.append(html);
            } else {
                $dataContainer.html(html);
            }

            if (productListContext.productRows.length) {
                $topSalesBlock.hide();
                return;
            }

            $topSalesBlock.show();
            topSalesListContext = {
                productRows: _.chunk(data.interestingProducts.items, 4)
            };
            var topSalesHtml = this.template(topSalesListContext);
            $topSalesContainer.html(topSalesHtml);

            renderProductCarousel();
        }
    };

    var filtersContext = {
        catalog: {
            allCatalogs: []
        },
        category: {
            allCategories: []
        },
        group: {
            allGroups: []
        },
        brand: {
            allBrands: []
        }
    };

    var filters = {
        catalog: {
            source: {},
            template: {},
            mobileSource: {},
            mobileTemplate: {},
            render: function (filterData) {
                Object.assign(filtersContext.catalog, filterData);
                var html = this.template(filtersContext.catalog);
                $filters.$catalog.html(html);

                var mobileHtml = this.mobileTemplate(filtersContext.catalog);
                $filters.$mobileCatalog.html(mobileHtml);
                jcf.replaceAll();
            }
        },
        category: {
            source: {},
            template: {},
            mobileSource: {},
            mobileTemplate: {},
            render: function (filterData) {
                Object.assign(filtersContext.category, filterData);
                var html = this.template(filtersContext.category);
                $filters.$category.html(html);

                var mobileHtml = this.mobileTemplate(filtersContext.category);
                $filters.$mobileCategory.html(mobileHtml);
                jcf.replaceAll();
            }
        },
        group: {
            source: {},
            template: {},
            mobileSource: {},
            mobileTemplate: {},
            render: function (filterData) {
                Object.assign(filtersContext.group, filterData);
                var html = this.template(filtersContext.group);
                $filters.$group.html(html);

                var mobileHtml = this.mobileTemplate(filtersContext.group);
                $filters.$mobileGroup.html(mobileHtml);
                jcf.replaceAll();
            }
        },
        brand: {
            source: {}, template: {},
            mobileSource: {}, mobileTemplate: {},
            render: function (filterData) {
                Object.assign(filtersContext.brand, filterData);
                var html = this.template(filtersContext.brand);
                $filters.$brand.html(html);

                var mobileHtml = this.mobileTemplate(filtersContext.brand);
                $filters.$mobileBrand.html(mobileHtml);
                jcf.replaceAll();
            }
        }
    };

    function itemsPerPage() {
        return window.innerWidth < 768 ? 42 : 40;
    }

    function maxVisiblePages() {
        return window.innerWidth < 768 ? 6 : 10;
    }

    var options = {
        showCategory: true,
        showCatalog: true,
        showGroup: true,
        showBrand: true,
        showPageNumber: true,
        showPageItemsCount: true,
        updateBrandFilter: false,
        updateGroupFilter: false,
        updateCategoryFilter: false,
        updateCatalogFilter: false,
        defaultSortBy: 'topSales',
        defaultSortByForSearchByText: 'score',
        apiUrl: '/umbraco/api/products/getpaginated',
        title: '',
        metaDescription: '',
        searchParams: window.location.search
    };

    var pagination = {
        first: '&laquo;',
        last: '&raquo;',
        prev: '&lsaquo;',
        next: '&rsaquo;',
        startPage: 1,
        totalPages: 1,
        visiblePages: maxVisiblePages(),
        orderBy: options.defaultSortBy,
        sort: 0,
        initiateStartPageClick: false,
        onPageClick: pageClicked,
        isShowMore: false,
        itemsPerPage: 0
    };

    var bitMaskObj = {
        category: '00',
        sumGroup: '00',
        sumBrand: '00',
        availableItem: 0,
        newItem: 0,
        groupList: [],
        brandList: [],
        isAction: false,
        currentPage: '',
        currentLanguage: ''
    };

    function changeCheckBoxState(id) {
        var targetCheckbox = null;
        if (id.includes('mobile')) {
            targetCheckbox = $('#' + id.replace('mobile-', ''));
        } else {
            targetCheckbox = $('#mobile-' + id);
        }
        targetCheckbox.prop('checked', !targetCheckbox.prop('checked'));
    }

    function setParams() {
        var currentUrl = window.location.pathname;
        var currentLanguage = currentUrl.split('/').filter(item => item)[0]; //If the default language is Ukraine, the first item will be 'catalog'

        if (currentLanguage !== 'catalog') {
            currentUrl = currentUrl.split('/').filter(item => item).slice(1).join('/');
            bitMaskObj.currentLanguage = currentLanguage;
        }

        var currentPage = currentUrl.split('/').filter(item => item).slice(0, 1);
        var splittedUrl = currentUrl.split('/').filter(item => item).slice(1);
        var currentBitData = splittedUrl.reverse()[0];
        if (currentBitData) {
            var categoryLevel = currentBitData.slice(0, 2);
            var groupCount = currentBitData.slice(2, 4);
            var brandsCount = currentBitData.slice(4, 6);
            bitMaskObj.currentPage = currentPage;
            bitMaskObj.category = categoryLevel;
            bitMaskObj.sumGroup = groupCount;
            bitMaskObj.sumBrand = brandsCount;
            bitMaskObj.availableItem = currentBitData.slice(6, 7);
            bitMaskObj.newItem = currentBitData.slice(7, 8);
        }

        var endGroupsLevel = Number(groupCount) + 1;
        var endBrandsLevel = endGroupsLevel + Number(brandsCount);
        bitMaskObj.groupList = splittedUrl.slice(endBrandsLevel - Number(groupCount), endBrandsLevel);
        bitMaskObj.brandList = splittedUrl.slice(1, endBrandsLevel - Number(groupCount));
    }
    setParams();

    function sortInput(elem) {
        var id = elem.id.replace('mobile-', '');

        if (id === 'new' || id === 'available' || id === 'action') {
            toggleItemByState(id);

        } else {
            initSortElem(elem);
        }

        changeCheckBoxState(elem.id)
    }

    function initSortElem(elem) {
        var id = elem.id.replace('mobile-', '');

        if (elem.name === 'Groups') {
            toggleGroupItem(id);
        } else if (elem.name === 'Brands') {
            toggleBrandItem(id)
        }
    }

    function filterPath() {
        var path = window.location.pathname;
        var checkLanguage = path.split('/').filter(item => item)[0]; //If the default language is Ukraine, the first item will be 'catalog'

        if (checkLanguage !== 'catalog') {
            path = path.split('/').filter(item => item).slice(1).join('/');
        }

        var splittedPath = path.split('/').filter(item => item).slice(1);
        var categoryPath = splittedPath.slice(0, bitMaskObj.category);
        splittedPath = splittedPath.slice(0, splittedPath.length - 1);
        path = [
            ...categoryPath,
            ...bitMaskObj.groupList,
            ...bitMaskObj.brandList
        ].join('/');

        var newMask = createBitMask();
        var newUrl = '/' + bitMaskObj.currentPage;
        
        if (path) {
            newUrl = (newUrl === '/'? '' : newUrl) + '/' + path;
        }
        if (bitMaskObj.currentLanguage) {
            newUrl = "/" + bitMaskObj.currentLanguage + (newUrl === '/'? '' : newUrl) + '/' + newMask;
        } else {
            newUrl = (newUrl === '/'? '' : newUrl) + '/' + newMask;
        }

        history.pushState(null, null, newUrl);
    }

    function toggleBrandItem(id) {
        var value = +bitMaskObj.sumBrand;
        if (bitMaskObj.brandList.includes(id)) {
            bitMaskObj.brandList = bitMaskObj.brandList.filter(elem => elem !== id);
            value = value - 1;
        } else {
            bitMaskObj.brandList.push(id);
            value = value + 1;
        }

        bitMaskObj.sumBrand = formatValue(value);
        filterPath();
    }

    function toggleGroupItem(id) {
        var value = +bitMaskObj.sumGroup;
        if (bitMaskObj.groupList.includes(id)) {
            bitMaskObj.groupList = bitMaskObj.groupList.filter(elem => elem !== id);
            value = value - 1;
        } else {
            bitMaskObj.groupList.push(id);
            value = value + 1;
        }

        bitMaskObj.sumGroup = formatValue(value);
        filterPath();
    }

    function formatValue(num) {
        return num <= 9 ? '0' + num : num;
    }

    function toggleItemByState(input) {
        if (input === 'new') {
            bitMaskObj.newItem = bitMaskObj.newItem == 0 ? 1 : 0;
        }

        if (input === 'available') {
            bitMaskObj.availableItem = bitMaskObj.availableItem == 0 ? 1 : 0;
        }

        if (input === 'action') {
            bitMaskObj.isAction = !bitMaskObj.isAction;
        }

        filterPath();
    }

    function createBitMask() {
        return bitMaskObj.category + bitMaskObj.sumGroup + bitMaskObj.sumBrand + bitMaskObj.availableItem + bitMaskObj.newItem;
    }

    function loadData() {
        querystring.change(getParams(options));
        $.ajax({
            method: "GET",
            url: options.apiUrl
        }).done(function (json) {
            unBindSubmitOnPreviousForms();
            timeList.render(json);
            if (options.updateBrandFilter) {
                filters.brand.render(json.filter);
            }
            if (options.updateCategoryFilter) {
                filters.category.render(json.filter);
            }
            if (options.updateCatalogFilter) {
                filters.catalog.render(json.filter);
            }
            if (options.updateGroupFilter) {
                filters.group.render(json.filter);
            }

            MUI.init();
            reloadPagination(json.result);
            reloadShowMoreButton();

            initFilterChangeEvent();
            initFormChangeEvent();
            
            updateMetaTags(json.filter.titleEnd, json.filter.metaDescriptionEnd);

            updateFilterPills();
            togglerProductOrder();
            initAnimations();

            updateLanguageLinks(json.languageLinks);
        });
    }

    function unBindSubmitOnPreviousForms() {
        //on click 'more products' duplicate event on submit in each form on page
        $('[data-muifrm="additem"]').unbind("submit");
    }

    function pageClicked(event, page) {
        pagination.isShowMore = false;
        pagination.startPage = page;
        scrollTop();
        loadData();
    }

    function scrollTop() {
        $('html, body').animate(
            {
                scrollTop: 0
            },
            400,
            'linear'
        );
    }

    function getParams(args) {
        var params = new URLSearchParams();
        params.append("p.n", pagination.startPage);
        params.append("p.d", pagination.sort);

        if (pagination.itemsPerPage && pagination.itemsPerPage > 0 && pagination.isShowMore) {
            params.append('ipp', pagination.itemsPerPage);
        }
        if (args === undefined) {
            return params.toString();
        }
        if (args.showPageNumber === false) {
            params.delete("p.n");
        }
        if (args.showPageItemsCount === false) {
            params.delete("p.c");
        }
        if (bitMaskObj.isAction) {
            params.append("isAction", 1);
        }
        if (!bitMaskObj.isAction) {
            params.delete("isAction");
        }

        var currentParams = new URLSearchParams(args.searchParams);
        var currentSearchValue = currentParams.get("s");
        var isMobile = window.innerWidth < 768;
        var searchTerm = $(isMobile ? '#searchInputMobileFilter' : '#searchInputFilter').val();

        searchTerm
            ? params.append("s", searchTerm)
            : (currentSearchValue ? params.append("s", currentSearchValue) : null);

        params.append("p.s", pagination.orderBy);

        return params.toString();
    }

    function initPagination() {
        if (pagination.totalPages) {
            $pagination.twbsPagination(pagination);
        }
    }

    function initShowMoreButton() {
        $showMoreButton = $('#showMoreButton');
        reloadShowMoreButton();
        $showMoreButton.click(showMoreButtonOnClick);
    }

    function reloadShowMoreButton() {
        if (pagination.startPage === pagination.totalPages) {
            $showMoreButton.hide();
        }
    }

    function showMoreButtonOnClick() {
        var currentPage = +$("li.active").find('a.page-link')[0].text;
        if (currentPage < pagination.totalPages) {
            pagination.isShowMore = true;
            pagination.itemsPerPage = itemsPerPage();
            var nextPage = currentPage + 1;
            pagination.startPage = nextPage;
            loadData();
        }
    }

    function reloadPagination(paginationData) {
        if (paginationData.totalPages < 2) {
            $pagination.hide();
            $showMoreButton.hide();
        } else {
            $pagination.show();
            $showMoreButton.show();
        }
        pagination.startPage = paginationData.currentPage ? paginationData.currentPage : 1;
        pagination.totalPages = paginationData.totalPages;
        $pagination.empty();
        $pagination.removeData("twbs-pagination");
        $pagination.unbind("page");
        initPagination();
    }

    function initFilterChangeEvent() {
        $('.side-filters input[type=checkbox]').unbind('change');
        $('.side-filters input[type=checkbox]').on("change", function (e) {
            sortInput(e.target)
        });
    }

    function initFormChangeEvent() {
        $filtersForm.unbind('change');

        $filtersForm.change(function (e) {
            pagination.startPage = 1;
            pagination.isShowMore = false;
            loadData();
            // scrollTop(); 
        });

        $applyFilterButton.unbind('click');
        $applyFilterButton.click(function (e) {
            e.preventDefault();

            var isMobileFilter = $(this).hasClass('mobile-apply-filter');
            if (isMobileFilter) {
                //close popup
                $('.mobile-filters').removeClass("popup-active");
                $('.filters-popup').hide();
            }
        });
    }

    function initBrandFilter() {
        $filters.$brand = $('* [data-filter="brand"]');
        $filters.$mobileBrand = $('* [data-filter="mobile-brand"]');

        filters.brand.source = $('#data-filter-brand-template').html();
        filters.brand.template = Handlebars.compile(filters.brand.source);

        filters.brand.mobileSource = $('#mobile-data-filter-brand-template').html();
        filters.brand.mobileTemplate = Handlebars.compile(filters.brand.mobileSource);
    }

    function initGroupFilter() {
        $filters.$group = $('* [data-filter="group"]');
        $filters.$mobileGroup = $('* [data-filter="mobile-group"]');

        filters.group.source = $('#data-filter-group-template').html();
        filters.group.template = Handlebars.compile(filters.group.source);

        filters.group.mobileSource = $('#mobile-data-filter-group-template').html();
        filters.group.mobileTemplate = Handlebars.compile(filters.group.mobileSource);
    }

    function initCategoryFilter() {
        $filters.$category = $('* [data-filter="category"]');
        $filters.$mobileCategory = $('* [data-filter="mobile-category"]');

        filters.category.source = $('#data-filter-category-template').html();
        filters.category.template = Handlebars.compile(filters.category.source);

        filters.category.mobileSource = $('#mobile-data-filter-category-template').html();
        filters.category.mobileTemplate = Handlebars.compile(filters.category.mobileSource);
    }

    function initCatalogFilter() {
        $filters.$catalog = $('* [data-filter="catalog"]');
        $filters.$mobileCatalog = $('* [data-filter="mobile-catalog"]');

        filters.catalog.source = $('#data-filter-catalog-template').html();
        filters.catalog.template = Handlebars.compile(filters.catalog.source);

        filters.catalog.mobileSource = $('#mobile-data-filter-catalog-template').html();
        filters.catalog.mobileTemplate = Handlebars.compile(filters.catalog.mobileSource);
    }

    function initSearch() {
        $('#searchInputFilter, #searchInputMobileFilter').on('input', function (e) {
            loadData();
        })
    }

    function updateMetaTags(titleEnd, metaDescriptionEnd) {
        initTitle(titleEnd);
        initMetaDescription(metaDescriptionEnd);

        updateMetaTagEnding('og:title', titleEnd);
        updateMetaTagEnding('og:description', metaDescriptionEnd);
    }

    function initTitle(titleEnd) {
        if (titleEnd && titleEnd.length > 0) {
            let titleEndForRemoving = document.title.substring(0, document.title.indexOf('|') + 2) + titleEnd;
            document.title = removeSeoTitleEnd(titleEndForRemoving)
        }
    }

    function removeSeoTitleEnd(title) {
        var maxAllowedCountOfSymbols = 70;

        if (title.length > maxAllowedCountOfSymbols) {

            var lastPipeIndex = title.lastIndexOf('|');

            if (lastPipeIndex !== -1) {
                return title.substring(0, lastPipeIndex).trim();
            }
        }

        return title;
    }

    function initMetaDescription(metaDescriptionEnd) {
        if (metaDescriptionEnd && metaDescriptionEnd.length > 0) {
            var metaDescriptionTag = $('meta[name="description"]');

            var newMetaDescription = metaDescriptionTag.attr('content');
            newMetaDescription = newMetaDescription.substring(0, newMetaDescription.indexOf('|') + 2) + metaDescriptionEnd;

            metaDescriptionTag.attr('content', newMetaDescription);
        }
    }

    function updateLanguageLinks(languageLinks) {
        for (let key in languageLinks) {

            $('#' + key).attr('href', languageLinks[key]);
        }
    }

    var resetFilter = function (item) {
        var currentId = $(item).data('id');
        var newId = currentId.replace('mobile-', '');
        if ($('#' + newId).length === 0) {
            return;
        }

        if (newId === 'available' || newId === 'new' || newId === 'action') {
            toggleItemByState(newId);
        }

        if (bitMaskObj.groupList.includes(newId)) {
            toggleGroupItem(newId);
        }

        if (bitMaskObj.brandList.includes(newId)) {
            toggleBrandItem(newId);
        }

        var input = $('#' + newId);

        input.each(function () {
            changeCheckBoxState(currentId)
            this.checked = false;
        });

        loadData();
    };

    var resetAllFilters = function () {
        bitMaskObj.groupList = [];
        bitMaskObj.brandList = [];
        bitMaskObj.sumGroup = '00';
        bitMaskObj.sumBrand = '00';
        bitMaskObj.availableItem = 0;
        bitMaskObj.newItem = window.location.pathname.includes('novelties') ? 1 : 0;
        filterPath();

        //filters
        $('input[type=checkbox]:checked').prop('checked', false);
        loadData();
    };

    function updateFilterPills() {
        $filterPills.html('');

        var fields = $('input[type=checkbox]:checked');

        if (fields.length === 0) {
            return;
        }

        var pills = [];
        fields.each(function () {
            var value = $(this).val();

            if (pills[value]) {
                return;
            }
            var currentId = $(this).attr('id').replace('mobile-', '');
            var newItem = '<li class="filter-pill" data-id="' + currentId + '">' + value + ' <i class="icon-close"></i></li>';

            $filterPills.append(newItem);
            $('li[data-id=' + currentId + ']').on('click', function () {
                resetFilter(newItem);
            })
            pills[$(this).val()] = true;
        });

        var resetAllLabel = $('#ResetAll').val();
        var resetAllFiltersButton = '<li class="reset-filters" >' + resetAllLabel + '<i class="icon-close"></i></li>';
        $filterPills.append(resetAllFiltersButton);
        $('.reset-filters').on('click', function () {
            resetAllFilters(resetAllFiltersButton);
        })
    }

    function togglerProductOrder() {
        var productOrder = $('.products-order');
        $('.not-available').length > 0 ? productOrder.css('display', 'none') : productOrder.css('display', 'block');
    }

    function renderProductCarousel() {
        if ($('* .data-container .product-list').length < 1) {
            productCarousel();
        }
    }

    (function () {
        if (!opts) {
            opts = {};
        }
        Object.assign(options, opts);
        $pagination = $('#pagination');
        $filtersForm = $('*[data-filters]');
        $order = $('.products-order');
        $filterPills = $('.selected-filters');
        $applyFilterButton = $('.btn-apply-filter');
        $dataContainer = $('* [data-container]');
        $topSalesContainer = $('* [data-top-sales-container]');
        $topSalesBlock = $('#top-sales-products');
        timeList.source = $('#product-box-list-template').html();
        timeList.template = Handlebars.compile(timeList.source);

        if (options.updateBrandFilter) {
            initBrandFilter();
        }
        if (options.updateCategoryFilter) {
            initCategoryFilter();
        }
        if (options.updateCatalogFilter) {
            initCatalogFilter();
        }
        if (options.updateGroupFilter) {
            initGroupFilter();
        }
        pagination.totalPages = $pagination.data('totalpages');
        pagination.startPage = $pagination.data('currentpage');
        pagination.orderBy = options.defaultSortBy;

        initPagination();
        initShowMoreButton();

        updateFilterPills();

        initFormChangeEvent();
        initFilterChangeEvent();

        initSearch();
        initTitle(options.title);
        initMetaDescription(options.metaDescription);

        renderProductCarousel();

        // initAnimations();

        $order.change(function (e) {
            pagination.startPage = 1;
            var values = this.value.split('-');
            if (values.length > 0) {
                pagination.orderBy = values[0];
            }
            if (values.length > 1) {
                pagination.sort = values[1];
            } else {
                pagination.sort = 0;
            }
            loadData();
        });

    })();


}